import React, { useState } from "react";

const HoverEditable = ({ children, onEdit }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="hover-editable"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {isHovered && (
        <i className="edit-icon icon-edit" onClick={onEdit}></i>
      )}
    </div>
  );
};

export default HoverEditable;
